<template>
  <el-form-item :rules="item.rules" :label="item.label" :prop="item.key" v-if="item.key !== 'otherProperties'">
    <el-input v-if="item.type === 'input'" v-bind="$attrs" v-on="$listeners" :type="item.subType" :rows="item.rows" :placeholder="item.placeholder" :disabled="item.disable"></el-input>
    <el-checkbox v-else-if="item.type==='switch' && item.appearance==='checkbox'" v-bind="$attrs" v-on="$listeners" :disabled="item.disabled"></el-checkbox>
    <el-switch v-else-if="item.type==='switch'" v-bind="$attrs" v-on="$listeners" :disabled="item.disabled"></el-switch>
    <el-select v-else-if="item.type==='select'" v-bind="$attrs" v-on="$listeners" :multiple="item.multiple" :disabled="item.disabled" :multiple-limit="item.multipleLimit">
      <el-option v-for="o in item.options||ajaxOptions" :key="o.value" :label="o.label" :value="o.value" :disabled="o.disabled">
      </el-option>
    </el-select>
    <codemirror v-if="item.type === 'javascript'" v-bind="$attrs" v-on="$listeners" :options="cmOptions"></codemirror>
  </el-form-item>
</template>
<script>
// language
import 'codemirror/mode/javascript/javascript';
// hint
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/javascript-hint';
// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/comment-fold';
import 'codemirror/addon/fold/foldcode';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/indent-fold';
import 'codemirror/addon/fold/markdown-fold';
import 'codemirror/addon/fold/xml-fold';

export default {
  data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: 'text/javascript',
        theme: 'default',
        lineNumbers: true,
        lineWrapping: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
      },
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    addPro() {
      this.$emit('addPro');
    },
    delPro(index) {
      this.$emit('delPro', index);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/v-dynamic-form-item.vue